import React from 'react';
import { Image, Typography } from 'tfc-components';

import image from 'assets/images/home/whatwedo.png';
import Section from 'components/organisms/Section';

const WhatWeDo: React.FC = () => (
  <Section>
    <div className="p-about_whoWeAre p-about_whoWeAre-reverse">
      <div className="p-about_whatWeDo_image">
        <Image imgSrc={image} alt="Who we are" ratio={592 / 375} />
      </div>
      <div className="p-about_whoWeAre_content">
        <Typography.Text extendClasses="f-28x34" fontweight="600">
          Who We Are
        </Typography.Text>

        <Typography.Text
          fontweight="600"
          extendClasses="p-about_whoWeAre_subTitle"
        >
          At EVOL LABS, we:
        </Typography.Text>

        <ul className="p-about_whoWeAre_list">
          <li>
            <Typography.Text>
              Develop AI-native products that couldn’t exist before AI
            </Typography.Text>
          </li>
          <li>
            <Typography.Text>
              Validate ideas fast through rapid prototyping and user feedback
            </Typography.Text>
          </li>
          <li>
            <Typography.Text>
              Focus on desirability, feasibility, viability, and AI advantage
            </Typography.Text>
          </li>
          <li>
            <Typography.Text>
              Launch new products continuously — some become standalone
              companies assumptions
            </Typography.Text>
          </li>
        </ul>

        <Typography.Text
          fontweight="600"
          extendClasses="p-about_whoWeAre_subTitle p-about_whoWeAre_subTitle_italic"
        >
          Our studio model gives us the agility of a startup with the focus of a
          product team. We don’t outsource. We don’t wait for perfection. We
          move with urgency and learn from real signals
        </Typography.Text>
      </div>
    </div>
  </Section>
);

export default WhatWeDo;
